import { consume } from '@lit/context';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { PrintProofReviewDto, PrintProofStatusEnum } from '@/api-sdk';
import { global, GlobalComponentType } from '@/context';

import './status/fg-print-proof-status-pending';
import './status/fg-print-proof-status-processing';
import './status/fg-print-proof-status-reviewed';

@customElement('fg-print-proof-status')
export class FgPrintProofStatus extends LitElement {
  @property({ type: String })
  status?: PrintProofStatusEnum;

  @property({ type: Object })
  review?: PrintProofReviewDto | null;

  @consume({ context: global.context })
  globalContext!: GlobalComponentType;

  private openPrintProofDialog() {
    this.dispatchEvent(new CustomEvent('open-print-proof-dialog'));
  }

  render() {
    switch (this.status) {
      case PrintProofStatusEnum.pending_review:
        return html`
          <fg-configuration-print-pending
            part="${this.globalContext.layout}"
            @open-print-proof-dialog="${this.openPrintProofDialog}"
          ></fg-configuration-print-pending>
        `;
      case PrintProofStatusEnum.processing:
        return html`
          <fg-configuration-print-processing
            part=${this.globalContext.layout}
          ></fg-configuration-print-processing>
        `;
      case PrintProofStatusEnum.reviewed:
      case PrintProofStatusEnum.visual_designer_approved:
        return html`
          <fg-configuration-print-reviewed
            part=${this.globalContext.layout}
            .reviewStatus=${this.review}
            .printProofStatus=${this.status}
            @open-print-proof-dialog=${this.openPrintProofDialog}
          ></fg-configuration-print-reviewed>
        `;
    }
  }
}
